var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AK-List_Users"},_vm._l((_vm.users),function(user){return _c('users-list-item',{key:user.id,attrs:{"user":user,"user-data":_vm._f("getUserDataById")(user.id,_vm.usersData)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }